import { render, staticRenderFns } from "./Region.vue?vue&type=template&id=f12f9582"
import script from "./Region.vue?vue&type=script&lang=js"
export * from "./Region.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports